import qs from 'qs'

import { fetchExportFile } from '@features/expertReports'
import type { ExpertReportCompareWith, ReportExportFormat } from '@features/expertReports'

import { getCurrentLocale, getRequest } from '../../utils'
import type { ExpertBalanceSheetReport } from './types/expertBalanceSheetReport'

export const EXPERT_BALANCE_SHEET_COMPARE_COUNT = 1

export interface ExpertBalanceSheetQueryParams {
  /** Encoded period string, e.g. `fiscalyear:<organizationId>,2026`. */
  period: string
  compareCount: number
  compareWith: ExpertReportCompareWith
}

export interface FetchExpertBalanceSheetParams extends ExpertBalanceSheetQueryParams {
  organizationId: string
}

export interface FetchExpertBalanceSheetExportParams extends ExpertBalanceSheetQueryParams {
  format: ReportExportFormat
  organizationId: string
}

export const buildExpertBalanceSheetQueryString = ({
  compareCount,
  compareWith,
  period,
}: ExpertBalanceSheetQueryParams): string => qs.stringify({ compareCount, compareWith, period })

const getExpertBalanceSheetExportFallbackFileName = (format: ReportExportFormat): string => `Balance-sheet.${format}`

export const fetchExpertBalanceSheet = async ({
  compareCount,
  compareWith,
  organizationId,
  period,
}: FetchExpertBalanceSheetParams): Promise<ExpertBalanceSheetReport> => {
  const queryString = buildExpertBalanceSheetQueryString({ compareCount, compareWith, period })
  const { data } = await getRequest(`/v2/organizations/${organizationId}/reports/balanceSheet?${queryString}`, {
    'accept-language': getCurrentLocale(),
  })

  return data
}

export const fetchExpertBalanceSheetExport = async ({
  compareCount,
  compareWith,
  format,
  organizationId,
  period,
}: FetchExpertBalanceSheetExportParams) => {
  const queryString = buildExpertBalanceSheetQueryString({ compareCount, compareWith, period })
  const path = `/v2/organizations/${organizationId}/reports/balanceSheet.${format}?${queryString}`

  return fetchExportFile(path, format, getExpertBalanceSheetExportFallbackFileName(format))
}
